import React, {useEffect, useState} from "react";
import {onValue, push, ref, remove} from "firebase/database";
import { database } from "../../../../utils/firebase";
import { useNavigate, useParams } from "react-router-dom";
import {
    Breadcrumbs, Button,
    Dropdown,
    Link,
    ListItemDecorator,
    Menu,
    MenuButton,
    MenuItem,
    Typography
} from "@mui/joy";
import PrintIcon from "@mui/icons-material/Print";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteForever from "@mui/icons-material/DeleteForever";
import QuickReportGenerator from "../../QuickReportGenerator/QuickReportGenerator";
import {Add, MoreVert} from "@mui/icons-material";

const App = () => {
    const { leagueId } = useParams();
    const navigate = useNavigate();
    const payoutsRef = ref(database, `leagues/${leagueId}/payouts`);
    const [payoutIds, setPayoutIds] = React.useState([]);
    const [payoutData, setPayoutData] = React.useState({});
    const leagueRef = ref(database, `leagues/${leagueId}`);
    const [leagueData, setLeagueData] = React.useState({});

    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportType, setReportType] = useState('');

    useEffect(() => {
        onValue(payoutsRef, (snapshot) => {
            const data = snapshot.val();
            setPayoutData(data);
            const ids = data ? Object.keys(data) : [];
            setPayoutIds(ids);
        });

        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            setLeagueData(data);
        });
    }, [leagueId]);

    const handleUnixTime = (unixTime) => {
        const date = new Date(unixTime * 1000);
        const options = {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric',
            timeZone: leagueData.settings.timeZone
        };
        return date.toLocaleString(leagueData.settings.language, options);
    };

    const handleCreateNewPayoutSet = () => {
        const newPayoutSet = {
            name: 'New Payout Set',
            startDate: Math.floor(Date.now() / 1000),
            endDate: Math.floor(Date.now() / 1000) + 2592000, // 30 days later
            flights: {},
            playerHandicaps: {}
        };
        push(payoutsRef, newPayoutSet);
    };

    const handleCopyPayoutSet = (payoutId) => {
        const payoutSetToCopy = payoutData[payoutId];
        const newPayoutSet = {
            ...payoutSetToCopy,
            name: `${payoutSetToCopy.name} (Copy)`,
            playerHandicaps: payoutSetToCopy.playerHandicaps ? { ...payoutSetToCopy.playerHandicaps } : {}
        };
        push(payoutsRef, newPayoutSet);
    };

    const handleDeletePayoutSet = (payoutId) => {
        if (window.confirm("Are you sure you want to delete this payout set?")) {
            remove(ref(database, `leagues/${leagueId}/payouts/${payoutId}`));
        }
    };

    return (
        <div>
            <div className="container">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" onClick={() => navigate(`/app/league/${leagueId}/dashboard`)}>
                        {leagueData.name}
                    </Link>
                    <Typography sx={{ color: 'text.primary' }}>Payout Sets</Typography>
                </Breadcrumbs>
                <div className={"page-head-div"}>
                    <h1>Payout Settings</h1>
                    <Dropdown>
                        <MenuButton variant="plain" sx={{width: "35px", height: "35px"}}><PrintIcon/></MenuButton>
                        <Menu>
                            <MenuItem onClick={
                                () => {
                                    setReportModalOpen(true);
                                    setReportType('payoutsReport');
                                }}>Payouts Report</MenuItem>
                        </Menu>
                    </Dropdown>
                </div>
                <div className="dashboard">
                    <div className="ldb-matches-list">
                        {payoutIds.map((payoutId) => (
                            <div className="ldb-match" key={payoutId}>
                                {payoutData[payoutId].name} ({handleUnixTime(payoutData[payoutId].startDate)} - {handleUnixTime(payoutData[payoutId].endDate)})
                                <div className="dash-league-item-buttons">
                                    <Button className={'button-gradient'} onClick={() => navigate(`/app/league/${leagueId}/payout/${payoutId}`)}>Open</Button>
                                    <Dropdown>
                                        <MenuButton variant={"plain"} sx={{width: "15px"}}>
                                            <MoreVert/>
                                        </MenuButton>
                                        <Menu placement="bottom-end">
                                            {/*<MenuItem>*/}
                                            {/*    <ListItemDecorator sx={{color: 'inherit'}}><PrintIcon/></ListItemDecorator>{" "}*/}
                                            {/*    Generate Report*/}
                                            {/*</MenuItem>*/}
                                            {/*<ListDivider />*/}
                                            <MenuItem onClick={() => handleCopyPayoutSet(payoutId)}>
                                                <ListItemDecorator sx={{color: 'inherit'}}><ContentCopyIcon/></ListItemDecorator>{" "}
                                                Duplicate
                                            </MenuItem>
                                            <MenuItem variant="soft" color="danger" onClick={() => handleDeletePayoutSet(payoutId)}>
                                                <ListItemDecorator sx={{ color: 'inherit'}}><DeleteForever/></ListItemDecorator>{" "}
                                                Delete
                                            </MenuItem>
                                        </Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Button className={'button-gradient'} onClick={handleCreateNewPayoutSet} startDecorator={<Add/>}>Create New Handicap Set</Button>
                </div>
            </div>
            <QuickReportGenerator
                type={reportType}
                id={""}
                modalOpen={reportModalOpen}
                closeModal={() => setReportModalOpen(false)}
                leagueId={leagueId}
            />
        </div>
    );
};

export default App;